import { useState } from "react";
import { useT, LANGS } from "@/lib/i18n";
import { Globe } from "lucide-react";

export default function LangSwitcher({ dark = false }) {
  const { lang, setLang } = useT();
  const [open, setOpen] = useState(false);
  const cur = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <div className="relative" data-testid="lang-switcher">
      <button onClick={() => setOpen(!open)} className={`label-tiny flex items-center gap-1.5 ${dark ? "text-[hsl(var(--ink))]" : ""}`} data-testid="lang-toggle">
        <Globe className="w-3.5 h-3.5" /> {cur.label}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-3 bg-white shadow-lg border border-[hsl(var(--border))] min-w-[140px] z-50" data-testid="lang-menu">
          {LANGS.map((l) => (
            <button key={l.code} onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-3 text-sm hover:bg-[hsl(var(--surface))] ${l.code === lang ? "bg-[hsl(var(--surface))] font-medium" : ""}`}
              data-testid={`lang-${l.code}`}>
              <span className="text-[hsl(var(--terracotta))] mr-2 font-mono">{l.label}</span>{l.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
